import {AxiosPromise} from 'axios';

import {
    API_URL,
    HTTP_REQUEST_HEADER,
    HTTP_REQUEST_HEADER_ACCEPT_ENCODING_VALUE,
} from 'constants/api';
import {NEUTRAL_CATEGORY_ID} from 'constants/category';
import {ENDPOINTS} from 'constants/endpoints';
import {instanceGusaBackend} from 'libs/api';
import {SEARCH_PROVIDER_ALGOLIA} from '../constants/quickSearch';
import {SearchResultDataType} from '../types';

/**
 * Fetches search data with passed search keyword
 * @param {string} keyword - search word
 * @returns {AxiosPromise} - request's promise
 */
export const fetchSearchResults = (keyword: string): AxiosPromise<SearchResultDataType> =>
    instanceGusaBackend.get(`${ENDPOINTS.ELASTIC_CATEGORY}/${NEUTRAL_CATEGORY_ID}`, {
        params: {search_provider: SEARCH_PROVIDER_ALGOLIA, q: keyword},
        baseURL: API_URL,
        headers: {
            [HTTP_REQUEST_HEADER.ACCEPT_ENCODING]: HTTP_REQUEST_HEADER_ACCEPT_ENCODING_VALUE,
        },
    });
